import useFormatPrice from '../components/composables/useFormatPrice'

document.addEventListener('DOMContentLoaded', function () {
    const { formatPrice } = useFormatPrice()

    const tabs = document.querySelectorAll('.tab')
    const tabContents = document.querySelectorAll('.tab-content')

    function formatStorage(value) {
        return value >= 1000 ? (value / 1000).toFixed(1) + ' TB' : value + ' GB'
    }

    function calculatePrice(value, pricePerGB) {
        return value * pricePerGB
    }

    function updateDisplay(tabContent, value) {
        const slider = tabContent.querySelector('.storage-slider')
        const input = tabContent.querySelector('.storage-input')
        const priceValue = tabContent.querySelector('[data-value="price-value"]')
        const storageValue = tabContent.querySelector('[data-value="storage-value"]')
        const pricePerGB = parseFloat(tabContent.getAttribute('data-price-per-gb'))
        const language = tabContent.getAttribute('data-language')
        const currency = tabContent.getAttribute('data-currency')

        slider.value = value
        input.value = value

        const price = calculatePrice(value, pricePerGB)
        const formattedPrice = formatPrice(price, currency, language)

        storageValue.textContent = formatStorage(value)
        priceValue.textContent = formattedPrice

        updateOrderLink(tabContent, value)
    }

    function updateOrderLink(tabContent, storageValue) {
        const orderLink = tabContent.querySelector('a.order-link')

        if (orderLink) {
            const url = new URL(orderLink.href)
            const storageType = tabContent.getAttribute('data-tab')
            url.searchParams.set('storage', storageValue)
            url.searchParams.set('type', storageType)

            orderLink.href = url.toString()
        }
    }

    function updateMinMaxLabels(tabContent) {
        const slider = tabContent.querySelector('.storage-slider')
        const minLabel = tabContent.querySelector('[data-value="minimum"]')
        const maxLabel = tabContent.querySelector('[data-value="maximum"]')

        minLabel.textContent = formatStorage(parseInt(slider.min))
        maxLabel.textContent = formatStorage(parseInt(slider.max))
    }

    function initializeTabContent(tabContent) {
        const slider = tabContent.querySelector('.storage-slider')
        const input = tabContent.querySelector('.storage-input')
        const initialValue = parseInt(slider.value)

        updateDisplay(tabContent, initialValue)
        updateMinMaxLabels(tabContent)

        slider.addEventListener('input', () => {
            updateDisplay(tabContent, parseInt(slider.value))
        })

        input.addEventListener('input', () => {
            let value = parseInt(input.value)
            const min = parseInt(input.min)
            const max = parseInt(input.max)

            if (isNaN(value)) {
                value = min
            } else if (value < min) {
                value = min
            } else if (value > max) {
                value = max
            }

            updateDisplay(tabContent, value)
        })
    }

    tabContents.forEach(initializeTabContent)

    function switchTab(clickedTab) {
        tabs.forEach((tab) => tab.classList.remove('active'))
        tabContents.forEach((content) => content.classList.remove('active'))

        clickedTab.classList.add('active')
        const tabId = clickedTab.getAttribute('data-tab')
        const activeContent = document.querySelector(`.tab-content[data-tab="${tabId}"]`)
        activeContent.classList.add('active')

        const slider = activeContent.querySelector('.storage-slider')
        updateDisplay(activeContent, parseInt(slider.value))
    }

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => switchTab(tab))
    })

    // Activate the first tab by default
    switchTab(tabs[0])
})
